import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'

import { MinStayAutomationDialogComponent, MinStayAutomationDialogInput } from './min-stay-automation-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class MinStayAutomationDialogService {
  constructor(private dialog: DialogService) {}

  public open(data?: MinStayAutomationDialogInput) {
    const defaultConfig: MatDialogConfig<MinStayAutomationDialogInput> = {
      width: '700px',
      height: 'auto',
      data: data || {},
    }

    return this.dialog.openVariableDialog(MinStayAutomationDialogComponent, defaultConfig)
  }
}
